interface FixedNumber {
	(input: string | number): {
		fixedNumber: string
		rawNumber: number
	}
}

const useFixedNumber: FixedNumber = (input: string | number) => {
	let number: number

	if (typeof input === 'string') {
		number = parseFloat(input.replace(/[(,)+]/g, ''))
	} else {
		number = input
	}

	// Dos decimales SIEMPRE. Antes el ".00" se agregaba sólo cuando el número era entero, así
	// que un monto con un solo decimal se mostraba incompleto: 1334.4 salía "$1,334.4" en la
	// pantalla de cobro, junto a un subtotal que sí decía "$1,334.40". Los 40 usos de este
	// composable son montos de dinero, que nunca deben verse con un decimal suelto.
	const result = new Intl.NumberFormat(undefined, {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(Number.isFinite(number) ? number : 0)

	return {
		fixedNumber: result,
		rawNumber: number,
	}
}

export default useFixedNumber
